import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IDepositIconProps extends ISvgIconProps {

}

export class DepositIcon extends React.Component<IDepositIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 30 30">
                <g fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="15.4" cy="15.4" r="9.65" />
                    <path d="M15.5 21.552v3.533m0-19.533v3.533m-6.234 6.233H5.733m19.533 0h-3.533m-10.6404-4.40766-2.49821-2.4982M22.4063 22.22405l-2.4982-2.4982m-8.81576.00055-2.4982 2.49821M22.40605 8.4127l-2.4982 2.4982" />
                    <circle cx="15.4" cy="15.4" r="2.65" />
                </g>
            </SvgIcon>
        );
    }
}
